import React from 'react';
import { Box, Pagination, PaginationItem} from '@mui/material';

const CoursePagination = ({ totalPages, currentPage, handlePageChange }) => (
  <Box display="flex" justifyContent="flex-start" alignItems="center" mt={3} flexShrink={0}>
    <Pagination
      count={totalPages}
      page={currentPage}
      onChange={(event, value) => {
        handlePageChange(event, value);
      }}
      variant="outlined"
      sx={{
        "& .MuiPagination-ul": {
          flexWrap: "nowrap",
        },
      }}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          disabled={
            (item.type === "next" && currentPage >= totalPages) ||
            (item.type === "previous" && currentPage <= 1)
          }
        />
      )}
    />
  </Box>
);

export default CoursePagination;